export default "__VITE_ASSET__D4HxLrN8__"